/**
 * Tab Retrospectiva — snapshot + edição de campos livres.
 */

import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { retrospectivaAPI } from '../../../services/inovacaoAPI';

export default function RetrospectivaWS({ projeto }) {
  const [r, setR] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ riscos_materializados: '', aprendizados: '' });

  useEffect(() => {
    retrospectivaAPI.obter(projeto.id)
      .then((data) => {
        setR(data);
        setForm({
          riscos_materializados: data.riscos_materializados || '',
          aprendizados: data.aprendizados || '',
        });
      })
      .catch(() => setR(null))
      .finally(() => setLoading(false));
  }, [projeto.id]);

  async function salvar() {
    try {
      const atualizada = await retrospectivaAPI.atualizar(projeto.id, form);
      setR(atualizada);
      toast.success('Retrospectiva salva');
    } catch (e) {
      toast.error('Erro ao salvar');
    }
  }

  if (loading) return <div style={cardStyle}>Carregando…</div>;
  if (!r) {
    return (
      <div style={cardStyle}>
        <p style={{ color: '#bdc3c7' }}>
          Retrospectiva será gerada automaticamente quando o projeto for concluído.
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 16 }}>
      <div style={cardStyle}>
        <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>Snapshot</h3>
        <KV label="Horas planejadas" value={`${r.horas_planejadas_total}h`} />
        <KV label="Horas realizadas" value={`${r.horas_realizadas_total}h`} />
        <KV label="Buffer consumido" value={`${r.buffer_consumido_percentual}%`} />
        <KV label="Gerada em" value={new Date(r.gerada_em).toLocaleString('pt-BR')} />
        <KV label="Em release?" value={r.publicada_em_release ? 'Sim' : 'Não'} />
        {r.depoimento_solicitante && (
          <div style={{ marginTop: 16, padding: 12, background: '#f8f9fa', borderRadius: 6,
                        borderLeft: '3px solid var(--brand, #20a490)' }}>
            <div style={{ fontSize: '0.72rem', color: '#95a5a6', textTransform: 'uppercase',
                          marginBottom: 4 }}>Depoimento do solicitante</div>
            <div style={{ fontStyle: 'italic', color: '#555', fontSize: '0.88rem' }}>
              "{r.depoimento_solicitante}"
            </div>
          </div>
        )}
      </div>

      <div style={cardStyle}>
        <h3 style={{ margin: '0 0 16px', color: '#2c3e50' }}>Aprendizados & Riscos materializados</h3>
        <label style={label}>Riscos que se materializaram</label>
        <textarea style={textarea} value={form.riscos_materializados}
                  onChange={(e) => setForm({ ...form, riscos_materializados: e.target.value })} />
        <label style={label}>Aprendizados do projeto</label>
        <textarea style={textarea} value={form.aprendizados}
                  onChange={(e) => setForm({ ...form, aprendizados: e.target.value })} />
        <button onClick={salvar} style={{
          background: 'var(--brand, #20a490)', color: 'var(--brand-ink, #fff)', padding: '10px 24px',
          border: 'none', borderRadius: 6, cursor: 'pointer', marginTop: 12,
        }}>Salvar</button>
      </div>
    </div>
  );
}

function KV({ label, value }) {
  return (
    <div style={{ padding: '8px 0', borderBottom: '1px solid #ecf0f1' }}>
      <div style={{ fontSize: '0.72rem', color: '#95a5a6', textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</div>
      <div style={{ fontSize: '1rem', color: '#2c3e50', fontWeight: 500 }}>{value}</div>
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 12, padding: 20,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const label = { display: 'block', fontSize: '0.85rem', color: '#555', marginBottom: 4, marginTop: 8 };
const textarea = { width: '100%', padding: 10, minHeight: 80, borderRadius: 4,
                   border: '1px solid #ccc', fontFamily: 'inherit', fontSize: '0.9rem' };
